import { gql } from '@/shared/graphql/generated/cache';

export const getTradingStrategyLimits = gql(/* GraphQL */ `
  query getTradingStrategyLimits {
    limits: allTradingStrategyLimits {
      nodes {
        minimumDeploymentAmount
        minimumAddedFundsAmount
        asset
      }
    }
  }
`);
